module.exports = {"news":{"read":"Leer mais"}};